module.exports = __webpack_public_path__ + "media/images/result_sets/circles/1n9n7r4n-d085fe6ae099fd7c78979af92d66e4f2.svg";